import getShowAdControls from "selectors/ads/getShowAdControls";
import getUseMobileControls from "selectors/breakpoint/getUseMobileControls";
import getUseInactivity from "selectors/getUseInactivity";
import { createSelector } from "reselect";

const getCompactControlsInactive = (state) => state.inactivity.compactControls;
const getControlsInactive = (state) => state.inactivity.controls;
const getIsChapterCoverShowing = (state) => state.forceChapterCover;
const getIsStoryCoverShowing = (state) =>
  !state.route.params.chapterKey && !state.playerOptions.singleVideoPlayer;
const getIsAdPlaying = (state) => state.ads.adPlaying;

export default createSelector(
  getCompactControlsInactive,
  getControlsInactive,
  getIsAdPlaying,
  getIsChapterCoverShowing,
  getIsStoryCoverShowing,
  getShowAdControls,
  getUseInactivity,
  getUseMobileControls,
  (
    compactControlsInactive,
    controlsInactiveState,
    adIsPlaying,
    chapterCoverIsShowing,
    storyCoverIsShowing,
    showAdControls,
    useInactivity,
    useMobileControls,
  ) =>
    useInactivity &&
    controlsInactiveState &&
    !showAdControls &&
    !useMobileControls &&
    !compactControlsInactive &&
    !adIsPlaying &&
    !chapterCoverIsShowing &&
    !storyCoverIsShowing,
);
